var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgMyLocation = function SvgSvgMyLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 15.75A3.754 3.754 0 0 1 8.25 12 3.754 3.754 0 0 1 12 8.25 3.754 3.754 0 0 1 15.75 12 3.754 3.754 0 0 1 12 15.75m0-6A2.25 2.25 0 0 0 9.75 12 2.25 2.25 0 0 0 12 14.25 2.25 2.25 0 0 0 14.25 12 2.25 2.25 0 0 0 12 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 24a.75.75 0 0 1-.75-.75v-3.034a8.206 8.206 0 0 1-7.466-7.466H.75a.75.75 0 0 1 0-1.5h3.034a8.21 8.21 0 0 1 7.466-7.466V.75a.75.75 0 0 1 1.5 0v3.034a8.21 8.21 0 0 1 7.466 7.466h3.034a.75.75 0 0 1 0 1.5h-3.034a8.206 8.206 0 0 1-7.466 7.466v3.034A.75.75 0 0 1 12 24m0-18.75A6.76 6.76 0 0 0 5.25 12 6.76 6.76 0 0 0 12 18.75 6.76 6.76 0 0 0 18.75 12 6.76 6.76 0 0 0 12 5.25"
  })));
};
export default SvgSvgMyLocation;